// Function loadContactUsSearchBlock loads the ContactUsSearchBlock class by dynamically importing the js on demand if needed

export function loadContactUsSearchBlock($parentEl, isList = false) {


	let $wg = $parentEl.querySelector('[data-wg="ContactUsSearchBlock"]');

	if(!$wg) {
		// console.info('ContactUsSearchBlock: no widget found');
		return Promise.reject('ContactUsSearchBlock widget not found in the parent element');
	}
	return import(/* webpackChunkName: "wg-contact-us-search-block-chunk" */ '../widgets/contactUsSearchBlock').then(wg => {

		const { ContactUsSearchBlock } = wg;


		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="ContactUsSearchBlock"]');
			let instances = [];
			Array.from($wgCol).forEach(($wg, i) => {
				instances.push( new ContactUsSearchBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new ContactUsSearchBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the ContactUsSearchBlock widget');

}
